import { render } from "./IconScannedBarcode.vue?vue&type=template&id=60ff89b0"
import script from "./IconScannedBarcode.vue?vue&type=script&lang=ts"
export * from "./IconScannedBarcode.vue?vue&type=script&lang=ts"
script.render = render

export default script